
import pushMaps from './director/push-maps';
import personnelMaps from './director/personnel-maps';
import tableColumns from './director/table-columns';

export default {
    top_study_time: '学习时长',
    top_integral: '可用积分',
    top_course_hour: '学时',
    top_credit: '学分',
    top_how_to_get_integral: '如何获得积分？',
    top_identity: '身份',
    // -------hhy-----
    unit_day: '天',
    unit_hour: '小时',
    unit_minute: '分钟',
    no_data: '当前暂无符合条件的处理记录',
    no_member: '暂无团队成员!',
    search_placeholder: '请输入您要搜索的内容',
    load_more: '加载更多',
    no_more: '没有更多了',
    has_ended: '已结束',
    has_completed: '已结项',
    has_finished: '已完成',
    on_going: '进行中',
    wait_handle_record: '待处理记录',
    btn_train_manage: '班级管理',
    btn_train_detail: '班级详情',
    btn_detail: '查看详情',
    btn_go_lecturer: '去授课',
    btn_start_report: '开始提报',
    btn_continue_report: '继续提报',
    btn_start_markpaper: '开始评卷',
    btn_again_markpaper: '重新评卷',
    btn_go_invigilate: '进入监考',
    btn_go_approve: '去审批',
    btn_go_correct: '去批改',
    report_situation: ' 提报情况：',
    train_graduation_situation: '结业情况：',
    put_forward: '提报',
    exam_reference_person: '参考人：',
    exam_duration: '考试时长：',
    remain_exam_duration: '剩余时长：',
    invigilate: '监考',
    approve_originator: '送审人：',
    homework_submitter: '提交人：',
    team_members: '团队成员',
    all: '全部',
    team_contribution: '团队贡献',
    my_team: '我的团队',
    care_something: '大家都感兴趣',
    rank: '排行榜',
    go_approve_before_tip: '审批状态已变更，请重新刷新页面',
    office_page: '待办任务',
    knowledge: '知识',
    share: '纷享',
    this_year: '(本年度)',
    yesterday: '(昨天)',
    activity: '活跃度',
    bi_group: '比集团',
    avg_study_time: '人均学时(h)',
    all_members: '全部成员',
    label_fullName: '姓名：',
    placeholder_fullName: '请输入姓名',
    label_name: '账号：',
    placeholder_name: '请输入账号',
    serial_number: '序号',
    fullName: '姓名',
    name: '账号',
    phone_number: '手机号',
    email: '邮箱',
    position: '岗位',
    attributive_department: '归属部门',
    job: '职务',
    join_time: '入职时间',
    close: '关闭',
    search: '搜索',
    export: '导出',
    view: '查看',
    operating: '操作',

    /** 作品评审国际化 */
    belongMicroclass: '所属赛事：',
    contestant: '参赛者：',
    worksDetail: '查看作品',
    microclassStatus: {
        1: '待评审',
        2: '已评审',
        3: '全部',
        4: '已过期'
    },
    audit: '评审',
    reGrade: '重新评分',

    // -------qzm-----
    // -------xhf-----
    no_found: '数据未找到',
    personnel_nodata: '~暂无内容哟~',
    personnel_loading: '内容加载中...',
    types_list: [
        { key: '', value: '全部' },
        { key: 1, value: '课程' },
        { key: 2, value: '专题' },
        { key: 3, value: '考试' },
        { key: 4, value: '调研' },
        { key: 5, value: '培训' },
        { key: 6, value: '直播' },
        { key: 7, value: '认证考试' }
    ],
    types_list_show: [
        '',
        '课程',
        '专题',
        '考试',
        '调研',
        '培训',
        '直播',
        '认证',
        '学习包'
    ],
    type_colors: {
        0: '52,157,31', // 直播
        1: '233,164,89', // 课程
        2: '231,132,132', // 专题
        3: '68,193,191', // 考试
        4: '52,157,31', // 调研
        5: '0,174,255', // 班级
        6: '89,145,233', // 直播
        12: '89,145,233', // 新直播
        7: '68,193,191', // 认证考试
        8: '52,157,31' // 学习包
    },
    status_colors: {
        1: '96,200,189', // 未开始
        2: '0,174,255', // 进行中
        3: '240,114,80', // 报名中
        4: '238,103,103', // 策划中
        5: '90,175,116', // 待实施
        6: '104,152,220', // 实施中
        7: '167,131,89', // 待结项
        8: '136,136,136' // 已结束
    },
    warning_colors: {
        1: '#00AEFF', // 0%-50% 红色警告
        2: '#00AEFF', // 50%-75% 黄色显示
        3: '#00AEFF', // 50%-75% 蓝色显示

        // 1: '#F00', // 0%-50% 红色警告
        // 2: '#FF0', // 50%-75% 黄色显示
        // 3: '#00AEFF', // 50%-75% 蓝色显示
    },
    source_form: {
        1: '学习推送',
        2: '群组',
        3: '岗位',
        4: '职务',
        5: '主管'
    },
    'types-text': [
        '全部',
        '课程',
        '专题',
        '考试',
        '调研',
        '班级',
        '直播',
        '认证考试'
    ],
    'exam-status': {
        1: '未发布',
        2: '发布中',
        3: '未开始',
        4: '报名中',
        5: '进行中',
        6: '已结束',
        7: '信息更新中',
    },
    'exam-detail-record-status': {
        1: '待审核',
        2: '待考试',
        3: '考试中',
        4: '待评卷',
        5: '不及格',
        6: '及格',
        7: '良好',
        8: '优秀'
    },
    'exam-record-status': {
        1: '未开始',
        2: '进行中',
        4: '未提交',
        5: '待评卷',
        6: '及格',
        7: '不及格',
        8: '已完成',
        9: '良好',
        10: '优秀'
    },
    'exam-type': {
        // 3、集团认证考试    4、省级认证考试
        0: '全部',
        1: '正式考试',
        2: '非正式考试',
        3: '认证考试',
        4: '认证考试'
    },
    'exam-person-center-status': {
        1: '考试中', 2: '未开始', 3: '审核中', 4: '待评卷', 5: '已完成'
    },
    'research-activity-status': {
        1: '未发布',
        2: '未开始',
        3: '进行中',
        4: '已结束',
        5: '已撤销'
    },
    'research-record': {
        0: '未参与',
        1: '已完成'
    },
    'student-classinfo-status': {
        1: '草案', 2: '策划中', 3: '报名中', 4: '待实施', 5: '实施中', 6: '待结项', 7: '已结项', 8: '已撤销'
    },
    'course-info-study-status': {
        0: '未开始',
        1: '学习中',
        2: '已完成',
        3: '已放弃',
        4: '已完成',
        5: '待审核',
        6: '审核未通过'
    },
    'subject-status': {
        0: '草稿',
        1: '已上架',
        2: '已下架',
        3: '审核中',
        4: '已拒绝'
    },
    'live-status': {
        1: '未开始',
        2: '进行中',
        3: '已结束',
        4: '已撤销'
    },
    'gensee-status': {
        0: '未发布',
        1: '未开始',
        2: '进行中',
        3: '已结束',
        4: '已撤销'
    },
    'course-task-view-detail-status': {
        0: '未开始',
        1: '学习中',
        2: '已完成',
        3: '已放弃',
        4: '已完成'
    },
    'personnel-detail-activity-businessType': {
        0: '面授课程', 1: '考试', 2: '评估', 3: '调研', 4: '直播', 5: '作业', 6: '其他', 7: '考核考试', 8: '在线课程'
    },
    'personnel-detail-activity-status': {
        1: '未开始', 2: '未完成', 3: '已完成'
    },
    'center-stage': [
        ['未开始', { 未开始: 1, 未发布: 1, 待实施: 5, 报名中: 3 }],
        ['进行中', { 进行中: 2, 直播中: 2, 开考中: 2, 策划中: 4, 实施中: 6, 待结项: 7 }],
        ['已结束', { 已结束: 8, 已结项: 8, 已撤销: 8 }],
    ],
    'center-stage-status': {
        1: '进行中',
        2: '已撤销',
        3: '已结束'
    },
    'personnel-view': '人员视图',
    'task-view': '任务视图',
    minutes: ' 分钟',
    nameNumber: '请输入姓名或账号',
    graduation: '结业状态',
    score: '分数',
    result: '结果',
    source: '来源',
    'center.detail.all': '全部',
    'center.detail.completed': '已结业',
    'center.detail.notCompleted': '未结业',
    'center.detail.learn': ' 催学',
    'center.a.key.to.learn': ' 一键催学',
    'center.archives.research.status': '调研状态',
    'center.archives.live.start-time': '直播开始时间',
    'center.archives.live.start-play-time': '直播开播时间',
    'center.archives.live.end-time': '直播结束时间',
    'center.archives.ask.push-time': '发布时间',
    'center.class.class-period': '起止时间',
    'center.create.live.estimate.time': '预估时长',
    'center.detail.implementationDepartment': '实施部门',
    'center.detail.publishDepartment': '发布部门',
    'center.detail.teamMembers': '团队参与人数',
    'center.detail.search': '搜索',
    'center.detail.urge': '催办',
    'center.record.index': '序号',
    'center.record.memberFullName': '姓名',
    'center.record.memberName': '账号',
    'center.record.organization': '归属部门',
    'center.record.completion': '完成情况',
    'center.record.totalTime': '总学习时长',
    'center.record.graduation': '结业状态',
    'center.record.operation': '操作',
    'center.record.businessName': '活动名称',
    'center.study.course.studyTime': '最近学习时间',
    'center.study.position.finishStatus': '任务完成状态',
    'center.archives.course.detail.source-name': '资源名称',
    'center.archives.course.detail.source-type': '资源类型',
    'center.study.position.require': '选/必修',
    'center.archives.research.start-time': '开始时间',
    'center.study.course.study-time': '最近学习时间',
    'center.archives.course.status': '学习状态',
    'center.archives.course.grade': '学习成绩',
    'center.archives.live.join-status': '参与状态',
    'train.manage.study.isItCompulsory': '选/必修',
    'train.manage.activityName': '活动名称',
    'train.manage.activityType': '活动类型',
    'train.manage.teacher': '讲师',
    'train.manage.completionRate': '完成率',
    'train.manage.activity.startTime': '开始时间',
    'train.manage.activity.endTime': '结束时间',
    'train.info.study-time': '学习时长',
    'train.info.study-status': '学习状态',
    'study.exam.submitTime': '提交时间',
    'study.exam.complete': '完成状态',
    'study.util.chnNumChar': ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'],
    'study.util.charset': ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'],
    'study.util.chnUnitChar': ['', '十', '百', '千'],
    'study.util.prefix': '第',
    'study.util.suffixChapter': '章',
    'study.util.suffixSection': '节',
    'exam.exam.bussiness.exam-time': '考试时长',
    'exam.exam.bussiness.exam-type': '考试类型',
    'exam-subject.dialog.to-be-review': '待评卷',
    'exam.pass': '及格',
    'exam.flunk': '不及格',
    'exam.good': '良好',
    'exam.excellent': '优秀',
    'exam.research-activity.manage.involvement-time': '参与时间',
    rushLearnTips: {
        class: '请勾选至少一个未结业选项',
        course: '请勾选至少一个未开始选项',
        exam: '请勾选至少一个未开始选项',
        live: '请勾选至少一个未参与选项',
        research: '请勾选至少一个未参与选项',
        subject: '请勾选至少一个未开始选项',
        examInfo: '所选的考生记录中含有非未开始的数据，请重新选择',
        researchInfo: '所选的学员记录中含有已完成的数据，请重新选择'
    },
    examTips: '该资源已不存在',
    'push-sudy': {
        ...pushMaps
    },
    personnel: {
        ...personnelMaps
    },
    'table-columns': {
        ...tableColumns
    },
    loading: '努力加载中...'
};
